import { lazy } from 'react';

const ReceivedMarketerTransformerTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/marketer/consult/received-transfer-info',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default ReceivedMarketerTransformerTransferConfig;


